import { gql } from '@apollo/client'

export const GET_JOB_LISTING_TEMPLATES = gql`
  query GetJobListingTemplates($status: JobListingTemplateStatus, $search: String) {
    jobListingTemplates(status: $status, search: $search) {
      jobListingTemplateId
      name
      description
      status
      createdAt
      updatedAt
      createdById
      steps {
        jobListingTemplateStepId
        stepType
        customStepId
        customStep {
          label
        }
        order
      }
      questions {
        jobListingTemplateQuestionId
        customQuestionId
        isRequired
        visibility
        order
        question {
          customQuestionId
          label
          key
          fieldType
          options {
            customQuestionOptionId
            label
            order
          }
        }
      }
      createdBy {
        employeeId
        firstName
        lastName
        status
      }
    }
  }
`

export const GET_JOB_LISTING_TEMPLATE = gql`
  query GetJobListingTemplate($id: String!) {
    jobListingTemplate(id: $id) {
      jobListingTemplateId
      name
      description
      status
      createdAt
      updatedAt
      createdById
      steps {
        jobListingTemplateStepId
        stepType
        customStepId
        customStep {
          label
        }
        order
      }
      questions {
        jobListingTemplateQuestionId
        customQuestionId
        isRequired
        visibility
        order
        question {
          customQuestionId
          label
          key
          fieldType
          options {
            customQuestionOptionId
            label
            order
          }
        }
      }
      createdBy {
        employeeId
        firstName
        lastName
        status
      }
    }
  }
`

export const CREATE_JOB_LISTING_TEMPLATE = gql`
  mutation CreateJobListingTemplate($input: CreateJobListingTemplateInput!) {
    createJobListingTemplate(input: $input) {
      jobListingTemplateId
      name
      description
      status
      createdAt
      steps {
        jobListingTemplateStepId
        stepType
        customStepId
        customStep {
          label
        }
        order
      }
    }
  }
`

export const UPDATE_JOB_LISTING_TEMPLATE = gql`
  mutation UpdateJobListingTemplate(
    $id: String!
    $input: UpdateJobListingTemplateInput!
  ) {
    updateJobListingTemplate(id: $id, input: $input) {
      jobListingTemplateId
      name
      description
      status
      updatedAt
      steps {
        jobListingTemplateStepId
        stepType
        customStepId
        customStep {
          label
        }
        order
      }
    }
  }
`

export const DELETE_JOB_LISTING_TEMPLATE = gql`
  mutation DeleteJobListingTemplate($id: String!) {
    deleteJobListingTemplate(id: $id) {
      jobListingTemplateId
      name
      status
    }
  }
`
